import { render } from "./ProfileTab.vue?vue&type=template&id=63663dea&ts=true"
import script from "./ProfileTab.vue?vue&type=script&lang=ts"
export * from "./ProfileTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__